import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=9fec1234&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=9fec1234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fec1234",
  null
  
)

export default component.exports